import { podcastDeepLink } from "./deep-link";
import {
  librarySectionFromSearch,
  type LibrarySection,
} from "./library-navigation";

export function issueReaderUrl(
  issueId: string,
  articleId?: string | null,
  contextSearch?: string,
): string {
  const params = new URLSearchParams({ issue: issueId });
  if (articleId) params.set("article", articleId);

  const context = new URLSearchParams(contextSearch);
  const mode = context.get("mode");
  if (mode === "home" || mode === "periodicals" || mode === "podcasts") {
    params.set("mode", mode);
  }
  for (const key of ["q", "feed", "topic"]) {
    const value = context.get(key);
    if (value !== null) params.set(key, value);
  }
  return `/?${params.toString()}`;
}

export function readingArticleFromLocation(
  search: string,
  hash: string,
): string | null {
  const queryArticle = new URLSearchParams(search).get("article");
  let articleId: string;
  if (queryArticle !== null) {
    articleId = queryArticle.trim();
  } else {
    try {
      articleId = decodeURIComponent(hash.replace(/^#/, "")).trim();
    } catch {
      return null;
    }
  }
  return articleId.length > 0 && articleId.length <= 64 ? articleId : null;
}

export function libraryLocationFromUrl(
  pathname: string,
  search: string,
): LibrarySection {
  return podcastDeepLink(pathname, search)
    ? "podcasts"
    : librarySectionFromSearch(search);
}
